<section class="full-width p-r-30 flex-row flex-space-between-start">
    <app-page-header-title title="Dashboards"></app-page-header-title>
    <div class="d-flex">
        <app-organization-selector
            (organizationChange)="onOrganizationChange($event)"
            class="m-r-32"
        ></app-organization-selector>
        <app-timeframe-selector (timeframeChange)="onTimeframeChange($event)"></app-timeframe-selector>
        <div class="m-l-5">
            <a
                [href]="'https://www.bitdefender.com/business/support/en/124809-126871-dashboards.html'"
                class="ds-icon-FAQ fs-30 foundations-link"
                id="foundations_link"
                target="_blank"
            >
            </a>
        </div>
        <div
            *appEnableForRoles="[UserPermission.NotificationsSettingsRead]"
            class="m-t-3 m-l-5 notifications-container"
        >
            <span
                (click)="notificationsService.highlightNotificationsMenu()"
                class="ds-icon-notification_bell fs-24"
            >
            </span>
        </div>
    </div>
</section>

<div class="d-flex flex-grow flex-direction-column p-r-20">
    @if (isLoading) {
    <div class="table-spinner">
        <mat-spinner
            [diameter]="60"
            [strokeWidth]="4"
        ></mat-spinner>
    </div>
    } @if (!hasDashboards && !isLoading) {
    <div class="tabs">
        @if (activeOrganization) {
        <app-empty-state
            i18n-title
            title="No dashboards available for the {{ activeOrganization?.name }} organization"
            type="noResults"
            class="empty-state-height"
        >
            <span i18n>Please contact the support team at cst&#64;bitdefender.com</span>
        </app-empty-state>

        } @if (!activeOrganization) {
        <app-empty-state
            i18n-title
            title="No organization selected"
            type="noResults"
            class="empty-state-height"
        >
            <span i18n>Select an organization first.</span>
        </app-empty-state>
        }
    </div>

    } @if ((companyLoaded || identityService.company) && hasDashboards && !isLoading) {
    <div class="tabs">
        <div class="dashboard-buttons">
            @if (organizationService.currentlySelectedOrganizationHasChildren() || organizationService.isAllManagedCompaniesSelected) {

            <a
                [ngClass]="{
                    disabled:
                        !organizationService.currentlySelectedOrganizationHasChildren() &&
                        !organizationService.isAllManagedCompaniesSelected
                }"
                matRipple
                routerLink="summary"
                routerLinkActive="active-link"
                tabindex="1"
                ariaCurrentWhenActive="page"
            >
                Org. Summary
            </a>

            } @if (mdrDashboardsService.isPremiumEnterprise(activeOrganization)) {
            <a
                matRipple
                routerLink="overview"
                ariaCurrentWhenActive="page"
                tabindex="2"
                routerLinkActive="active-link"
            >
                Overview
            </a>
            } @if (!mdrDashboardsService.isPremiumEnterprise(activeOrganization)) {
            <a
                matRipple
                routerLink="service"
                routerLinkActive="active-link"
                ariaCurrentWhenActive="page"
                tabindex="3"
            >
                Service
            </a>
            } @if (mdrDashboardsService.isPremiumEnterprise(activeOrganization)) {
            <a
                matRipple
                routerLink="mdr-service"
                routerLinkActive="active-link"
                ariaCurrentWhenActive="page"
                tabindex="4"
            >
                MDR Service
            </a>
            } @if (mdrDashboardsService.isPremiumEnterprise(activeOrganization)) {
            <a
                matRipple
                routerLink="agent-actions"
                routerLinkActive="active-link"
                ariaCurrentWhenActive="page"
                tabindex="5"
            >
                Agent Actions
            </a>
            }

            <a
                matRipple
                routerLink="configuration"
                routerLinkActive="active-link"
                tabindex="6"
            >
                Configuration
            </a>
        </div>
    </div>
    }
    <router-outlet class="dashboard-router-outlet"></router-outlet>
</div>
